import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state:{
    qyValue:null,  //当前企业的id
    // autonym:123,  //实名的标志
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js